import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, filter, Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { every, some } from 'lodash';
import { UserPermission } from '../models/user-permission.enum';
import { selectUserHasPermission } from '../selectors/permission.selectors';
import { selectUser } from 'common/store/genesys-cloud/users/selectors/user.selectors';

@Injectable({
  providedIn: 'root'
})
export class GenesysUserPermissionService {
  constructor(private readonly store: Store) {}

  hasPermission$(userPermission: UserPermission): Observable<boolean> {
    return this.store.select(selectUser).pipe(
      filter(Boolean), // Wait for user to be loaded before deciding about permissions
      mergeMap(() => this.store.select(selectUserHasPermission(userPermission)))
    );
  }

  hasAnyPermission$(...userPermissions: UserPermission[]): Observable<boolean> {
    if (userPermissions?.length < 1) {
      return of(false);
    }

    return this.getIndividualPermissionChecks$(userPermissions).pipe(map((results) => some(results, Boolean)));
  }

  hasAllPermissions$(...userPermissions: UserPermission[]): Observable<boolean> {
    if (userPermissions?.length < 1) {
      return of(false);
    }

    return this.getIndividualPermissionChecks$(userPermissions).pipe(map((results) => every(results, Boolean)));
  }

  private getIndividualPermissionChecks$(expected: UserPermission[]): Observable<boolean[]> {
    return combineLatest(expected.map((e) => this.hasPermission$(e)));
  }
}
